const convertUnitToInt = function (value) {
  let unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
  const checkUnit = new RegExp("".concat(unit), 'i');
  const digit = value && value.replace(checkUnit, '');
  return parseInt(digit);
};

export default convertUnitToInt;